<template>
    <div class="line-item">
        <div class="line-item__header">
            <h3 data-qa="line-item-title">{{ itemName }}</h3>
            <p><span v-text="$store.getters.currencyPrefix"></span><span data-qa="line-item-price">{{ itemPrice.toLocaleString() }}</span><span v-if="!isCharge">/<span v-text="$store.getters.isYearly ? 'yr' : 'mo'" data-qa="line-item-billing-period"></span></span></p>
        </div>
        <div class="line-item__items">
            <slot></slot>
            <ul>
                <!-- Included items -->
                <li v-for="attachment in includedAttachments" :key="attachment.itemId" data-qa="line-item-included-items">
                    {{ attachment.customDescription }}
                </li>
                <!-- End included items -->

                <li v-if="itemDescription" v-text="itemDescription" data-qa="line-item-description"></li>

                <li v-for="customIncluded in customIncludedItems" :key="customIncluded" data-qa="line-item-custom-included-items">
                    {{ customIncluded }}
                </li>

                <li class="line-item__item line-item__item--discount" v-for="coupon in getCoupons" :key="coupon.id" :data-qa="`line-item-coupon_${coupon.id}`">
                    <span>
                        <InfoIcon :content="coupon.disclaimer[$store.getters.billingPeriod]" v-if="!!coupon.disclaimer && !!coupon.disclaimer[$store.getters.billingPeriod]"/> {{ buildCouponDescription(coupon) }}
                    </span>
                    <span v-text="coupon.discountedTotal"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import InfoIcon from '@/BuyNow/Components/InfoIcon.vue';
import { getBestTier, getTierKeyByMaxUnits, pluralize, priceFormat, sortCoupons } from '@/Util/helpers.js';
export default {
    data() {
        return {
            isCharge: false,
            adjustedPrice: 0,
        }
    },
    methods: {
        buildCouponDescription(coupon) {
            if (!!coupon.customPromoText) {
                return coupon.customPromoText[this.$store.getters.billingPeriod];
            }
            if (coupon.duration == 'limited_period') {
                if (coupon.type === 'fixed_amount') {
                    return `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off for ${coupon.period} ${pluralize(coupon.periodUnit, coupon.period)}`;
                }
                if (coupon.type === 'percentage') {
                    return `${coupon.amount / 100}% off for ${coupon.period} ${pluralize(coupon.periodUnit, coupon.period)}`;
                }
            }
            if (coupon.duration == 'one_time') {
                if (coupon.type === 'fixed_amount') {
                    return `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off one time`;
                }
                if (coupon.type === 'percentage') {
                    return `${coupon.amount / 100}% off one time`;
                }
            }
            if (coupon.duration == 'forever') {
                if (coupon.type === 'fixed_amount') {
                    return `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off forever`;
                }
                if (coupon.type === 'percentage') {
                    return `${coupon.amount / 100}% off forever`;
                }
            }
        },
    },
    components: {
        InfoIcon,
    },
    props: {
        item: Object,
        isAttachment: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        getCoupons() {
            this.adjustedPrice = this.itemPrice;
            let coupons = this.priceObject.coupons.map(coupon => coupon.toLowerCase());
            let allCoupons = this.$store.getters.itemCoupons.filter(item => {
                return coupons.includes(item.id.toLowerCase());
            });
            allCoupons = allCoupons.filter(coupon => {
                if (
                    this.$store.getters.selectedPlanId.includes('keap-max')
                    && (
                        !!this.$store.getters.cartInfo.selectedAddons.find(item => item.itemId.toLowerCase().includes('text-voice'))
                        && this.$store.getters.cartInfo.selectedAddons.find(item => item.itemId.toLowerCase().includes('text-voice')).quantity === 1
                    )
                    && (
                        coupon.id.toLowerCase().includes('annual-3mons-freetier1-voice-and-text')
                        || coupon.id.toLowerCase().includes('3mos-freetier1-voice-and-text')
                    )
                ) {
                    return false;
                } else {
                    return true;
                }
            }).sort((a, b) => {
                return sortCoupons(a, b);
            }).map(coupon => {
                let amount = 0;
                let negativeDiscount = false;
                let removeFromView = false;
                if (coupon.duration == 'limited_period') {
                    if (coupon.type === 'fixed_amount') {
                        amount = coupon.amount / 100;
                        this.adjustedPrice -= amount;
                    } else if (coupon.type === 'percentage') {
                        amount = priceFormat(this.adjustedPrice * ((coupon.amount / 100) / 100));
                        this.adjustedPrice -= this.adjustedPrice * ((coupon.amount / 100) / 100);
                    }
                    if (amount < 0 || this.adjustedPrice < 0) {
                        amount = this.itemPrice;
                        negativeDiscount = true;
                    }
                    if (this.itemPrice <= 0) {
                        removeFromView = true;
                    }
                    amount = `-${this.$store.getters.currencyPrefix}${amount}/${this.$store.getters.isYearly ? 'yr' : 'mo'}`;
                } else if (coupon.duration == 'one_time') {
                    if (coupon.type === 'fixed_amount') {
                        amount = coupon.amount / 100;
                        this.adjustedPrice = amount;
                    } else if (coupon.type === 'percentage') {
                        amount = priceFormat(this.adjustedPrice * ((coupon.amount / 100) / 100));
                        this.adjustedPrice -= this.adjustedPrice * ((coupon.amount / 100) / 100);
                    }
                    if (amount < 0 || this.adjustedPrice < 0) {
                        amount = this.itemPrice;
                        negativeDiscount = true;
                    }
                    if (this.itemPrice <= 0) {
                        removeFromView = true;
                    }
                    amount = `-${this.$store.getters.currencyPrefix}${amount}`;
                } else if (coupon.duration == 'forever') {
                    if (coupon.type === 'fixed_amount') {
                        amount = coupon.amount / 100;
                        this.adjustedPrice -= amount;
                    } else if (coupon.type === 'percentage') {
                        amount = priceFormat(this.adjustedPrice * ((coupon.amount / 100) / 100));
                        this.adjustedPrice -= this.adjustedPrice * ((coupon.amount / 100) / 100);
                    }
                    if (amount < 0 || this.adjustedPrice < 0) {
                        amount = this.itemPrice;
                        negativeDiscount = true;
                    }
                    if (this.itemPrice <= 0) {
                        removeFromView = true;
                    }
                    amount = `-${this.$store.getters.currencyPrefix}${amount}/${this.$store.getters.isYearly ? 'yr' : 'mo'}`;
                }

                return {
                    ...coupon,
                    discountedTotal: amount,
                    negativeDiscount,
                    removeFromView
                }
            }).filter(coupon => {
                return !coupon.removeFromView;
            });
            return allCoupons;
        },
        includedAttachments() {
            if (!this.isAttachment) {
                let includedAttachments = [...this.$store.state.cartInfo.pricing.plans.find(plan => plan.id == this.item.id).addons, ...this.$store.state.cartInfo.pricing.plans.find(plan => plan.id == this.item.id).charges].filter(item => item.type === 'mandatory' && !item.itemId.toLowerCase().includes('text-voice')).map(item => {
                    let unit = item.metadata.unitTitle || item.metadata.unitOfMeasure || item.unit || item.name;
                    unit = unit.split('|')[0];
                    return {
                        ...item,
                        customDescription: `Includes ${item.quantity} ${pluralize(unit, item.quantity)}`
                    }
                });
                return includedAttachments;
            }
            return [];
        },
        customIncludedItems() {
            if (!!this.item.metadata?.includedItems) {
                return this.item.metadata.includedItems;
            }
        },
        quantity() {
            return this.item.selectedQuantity;
        },
        priceObject() {
            let pricing = this.item.pricing.find(price => price.billingPeriodUnit == this.$store.getters.billingPeriod);
            if (!pricing) {
                this.isCharge = true;
                pricing = this.item.pricing[0];
            }
            return pricing;
        },
        itemPrice() {
            let tier;

            if (!!this.priceObject.model && this.priceObject.model === 'stairstep') {
                tier = getBestTier(this.priceObject.tiers, this.quantity || 1);
                return tier.unitPrice / 100;
            } else {
                tier = this.priceObject.tiers[0];
                return (tier.unitPrice / 100) * (this.quantity || 1);
            }
        },
        itemName() {
            let title = this.item.name;
            if (!!this.item.metadata && !!this.item.metadata.title) {
                title = this.item.metadata.title;
            }
            return title;
        },
        unit() {
            let unit = this.item.metadata.unitTitle || this.item.metadata.unitOfMeasure || this.item.unit || this.item.metadata.title || this.item.name;
            if (unit && unit.includes('|')) {
                unit = unit.split('|');
                return unit[0];
            }
            return unit;
        },
        rawUnit() {
            let unit = this.item.metadata.unitOfMeasure || this.item.unit;
            if (unit && unit.includes('|')) {
                unit = unit.split('|');
                return unit[0];
            }
            return unit;
        },
        itemDescription() {
            // Text & voice edge case
            if (this.item.itemId.toLowerCase().includes('text-voice') && !!this.item.metadata.tiers) {
                let tiers = this.item.metadata.tiers;
                let selectedTier = getTierKeyByMaxUnits(this.priceObject.tiers, this.quantity) - 1;
                let includedMessages = selectedTier >= 0 ? tiers[selectedTier].includedMessages : 0;
                let includedMinutes = selectedTier >= 0 ? tiers[selectedTier].includedMinutes : 0;
                return `${includedMessages.toLocaleString()} messages & ${includedMinutes.toLocaleString()} minutes`;
            }
            // End text & voice edge case

            // Additional text messages edge case
            if (this.item.itemId.toLowerCase().includes('500-additional-message')) {
                return `${(this.quantity * 500).toLocaleString()} text messages`;
            }
            // End additional text message edge case

            if (!!this.rawUnit) {
                return `${this.quantity.toLocaleString()} ${pluralize(this.rawUnit, this.quantity)}`;
            }

        },
    },
    watch: {

    }
};
</script>

<style lang="postcss" scoped>
</style>
